import { render, staticRenderFns } from "./CoInvestigatorTable.vue?vue&type=template&id=2c129532"
import script from "./CoInvestigatorTable.vue?vue&type=script&lang=js"
export * from "./CoInvestigatorTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports